<svelte:window bind:innerWidth={width} bind:innerHeight={height} />

<Background />

<main>
	{#if $crash}
		<Crash />
	{:else}
		{#if $connected}
			{#if $state === "JOINS"}
				{#if lastPosition === "PLAY"}
					<ProfileBadge />
				{/if}
			{/if}

			<div class="content">
				{#if $state === "IDLE"}
					<MainMenu {socket} />
				{/if}

				{#if $state === "JOINS"}
					{#if lastPosition === "WATCH"}
						<Host {socket} watch={$host?.daddy !== $profile.id} />
					{:else}
						<Game {socket} />
					{/if}
				{/if}

				{#if $showMessage}
					<Message />
				{/if}

				{#if $showProfile}
					<Profile {socket} />
				{/if}
			</div>
		{:else}
			<div class="content">
				<Loading />
			</div>
		{/if}
	{/if}
</main>

<Debug {socket} />

<style>
main {
	min-height: 100vh;
	display: block;
	padding: 0px;
	margin: 0px;
}
.content {
	height: 100vh;
	min-height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	position: relative;
}
</style>

<script>
import Background from "./components/Background.svelte"

import Loading from "./layout/Loading.svelte"
import MainMenu from "./layout/MainMenu.svelte"
import Host from "./layout/host/Host.svelte"
import Game from "./layout/join/Game.svelte"
import ProfileBadge from "./components/profile/Badge.svelte"
import Profile from "./popups/Profile.svelte"
import Message from "./popups/Message.svelte"
import Crash from "./popups/Crash.svelte"
import Debug from "./components/Debug.svelte"
import { showProfile, showMessage, host, profile, crash } from "./stores/index"
import Stores from "./stores/index"

import { state } from "./stores/state"

export let connected
export let socket
export let switchMode // fn

let width = 0
let height = 0
let lastPosition = "PLAY"

$: if (width > height && lastPosition !== "WATCH" && $connected) { // horizontal
	setNewMode("WATCH")	
} else if (width < height && lastPosition !== "PLAY" && $connected) { // vertical
	setNewMode("PLAY")
}

const setNewMode = mode => {
	switchMode(mode)	
	lastPosition = mode
	if ($connected) {
		socket.emit("mode", mode)
	}
}
</script>